"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HeaderSt = require("./Header.st.css");

var _Heading = _interopRequireDefault(require("../../Heading"));

var _Text = _interopRequireDefault(require("../../Text"));

var _hooks = require("./hooks");

var _StringUtils = require("../../utils/StringUtils");

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Card/Header/Header.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Header = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Header, _React$PureComponent);

  var _super = _createSuper(Header);

  function Header() {
    (0, _classCallCheck2["default"])(this, Header);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Header, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          suffix = _this$props.suffix,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-hook": dataHook,
        className: (0, _HeaderSt.st)(_HeaderSt.classes.root, {}, className),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _HeaderSt.classes.titleWrapper,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34,
          columnNumber: 9
        }
      }, (0, _StringUtils.isString)(title) ? /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
        dataHook: _hooks.DataHooks.title,
        size: "medium",
        children: title,
        className: _HeaderSt.classes.title,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 13
        }
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        "data-hook": _hooks.DataHooks.title,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 13
        }
      }, title), subtitle && (0, _StringUtils.isString)(subtitle) ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        dataHook: _hooks.DataHooks.subtitle,
        children: subtitle,
        secondary: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 13
        }
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        "data-hook": _hooks.DataHooks.subtitle,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 13
        }
      }, subtitle)), suffix && /*#__PURE__*/_react["default"].createElement("div", {
        "data-hook": _hooks.DataHooks.suffix,
        className: _HeaderSt.classes.suffix,
        children: suffix,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 11
        }
      }));
    }
  }]);
  return Header;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Header, "displayName", 'Card.Header');
(0, _defineProperty2["default"])(Header, "propTypes", {
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook: _propTypes["default"].string,

  /** Sets card title text value. Title can also be overridden to any other component. */
  title: _propTypes["default"].node.isRequired,

  /** Sets card subtitle text value. Subtitle can also be overridden to any other component. */
  subtitle: _propTypes["default"].node,

  /** Adds an empty container on the right side of a header. Used to store action buttons or other components. */
  suffix: _propTypes["default"].node,

  /** Specifies a CSS class name to be appended to the component’s root element. */
  className: _propTypes["default"].string
});
var _default = Header;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map